import React from 'react';
import PropTypes from 'prop-types';

import pallet from 'constants/colors';
import { Paper } from 'material-ui';

const styles = {
  tabs: {
    width: '100%',
  },
  container: {
    width: '100%',
    marginBottom: 24,
  },
  tabButtons: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: `1px solid ${pallet.dividerColor}`,
    flexWrap: 'wrap',
  },
  tabButton: {
    outline: 'none',
    border: 'none',
    backgroundColor: 'transparent',
    height: 60,
    fontSize: 15,
    paddingLeft: 18,
    paddingRight: 18,
    fontWeight: 600,
    color: pallet.titleColor,
    cursor: 'pointer',
    position: 'relative',
    alignItems: 'center',
  },
  active: {
    height: 2,
    width: 'calc(100% - 36px)',
    backgroundColor: pallet.primary1Color,
    position: 'absolute',
    bottom: 0,
  },
};

class KTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      tabs: React.Children.map(props.children, arg => arg),
    };
  }

  setIndex = index => this.setState({ index })

  render() {
    const { index, tabs } = this.state;
    return (
      <div style={styles.container}>
        <Paper zDepth={0} style={styles.tabs}>
          <div style={styles.tabButtons}>
            {tabs.map((t, i) => (
              <button
                style={styles.tabButton}
                key={`tab${i}`}
                onClick={() => this.setIndex(i)}
                className={i !== index ? 'no-print' : ''}
              >
                <div>{t.props.name}</div>
                {(i === index) && <div style={styles.active} />}
              </button>
            ))}
          </div>
          <div style={styles.tabContainer}>
            {tabs[index]}
          </div>
        </Paper>
      </div>
    );
  }
}

KTabs.propTypes = {
  children: PropTypes.node,
};

export default KTabs;



// WEBPACK FOOTER //
// ./src/components/KJRN/KTabs.js